/*
 * @Author:wyj
 * @Date: 2022-07-13 11:08:19
 * @LastEditors: Pension 744056574@qq.com
 * @LastEditTime: 2022-09-14 14:13:56
 * @Description:通知类弹窗提示
 *
 */
import { h } from "vue"
import { Notice } from "linkd-ui"
import NoticeWrapper from "./NoticeWrapper.vue"
type NoticePlacementType = "top" | "bottom" | "top-end" | "bottom-end"
interface NoticeOptions {
  content: any
  placement?: NoticePlacementType
  duration?: number
  manual?: boolean
  afterClose?: () => void
}
// const NoticeWrapper = NoticeWrapper1 as any
const time = 2500
const cont = (ops: NoticeOptions | string, close: () => void) =>
  typeof ops === "string"
    ? ops
    : typeof ops.content === "function"
    ? ops.content(close)
    : ops.content

function _common_notice(
  iconName: string,
  colorType: string,
  ops: NoticeOptions | string
) {
  const placement = typeof ops === "string" ? "top" : ops.placement || "top"
  Notice.open({
    placement,
    content: (close: () => void) => {
      return h(
        NoticeWrapper as any,
        {
          iconName,
          colorType,
        },
        {
          default: () => cont(ops, close),
        }
      )
    },
    duration: typeof ops === "string" ? time : ops.duration ?? time,
    afterClose: typeof ops === "string" ? undefined : ops.afterClose,
  })
}
function success(ops: NoticeOptions | string) {
  _common_notice("icon-shangpinyun_chenggong", "success", ops)
}
function warning(ops: NoticeOptions | string) {
  _common_notice("icon-shangpinyun_tishi", "warning", ops)
}
function error(ops: NoticeOptions | string) {
  _common_notice("icon-shangpinyun_shibai", "error", ops)
}
export { warning, error, success }
